import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IncidentInterface } from "../../../models/Incident";
import { CACHE_KEY_INCIDENT } from "../../../utils/constants";
import incidentService from "../../../services/incidentService";

interface AddIncidentContext {
  previousIncidents: IncidentInterface[];
}

const useAddIncident = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    IncidentInterface,
    Error,
    IncidentInterface,
    AddIncidentContext
  >({
    mutationFn: incidentService.Save,

    onMutate: () => {
      const previousIncidents =
        queryClient.getQueryData<IncidentInterface[]>([
          CACHE_KEY_INCIDENT,
          page,
          pageSize,
        ]) || [];

      return { previousIncidents };
    },

    onSuccess: (savedIncident) => {
      queryClient.setQueryData<IncidentInterface[]>(
        [CACHE_KEY_INCIDENT, page, pageSize],
        (incidents) =>
          incidents ? [savedIncident, ...incidents] : [savedIncident]
      );
    },

    onError: (error, newIncident, context) => {
      if (!context) return;

      queryClient.setQueryData<IncidentInterface[]>(
        [CACHE_KEY_INCIDENT, page, pageSize],
        context.previousIncidents
      );
    },
  });
};

export default useAddIncident;
